(() => {
  const root = window.Shopify?.routes?.root || '/';
  const drawer = document.querySelector('[data-cart-drawer]');
  const lines = document.querySelector('[data-cart-lines]');
  const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
  let toastTimer;

  const showToast = message => {
    const toast = document.querySelector('[data-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('visible'), 2800);
  };

  const setDrawer = open => {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('cart-open', open);
  };

  const renderCart = cart => {
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = cart.item_count; });
    const total = document.querySelector('[data-cart-total]');
    if (total) total.textContent = money.format(cart.total_price / 100);
    const remaining = Math.max(0, 7500 - cart.total_price);
    const message = document.querySelector('[data-shipping-message]');
    const progress = document.querySelector('[data-shipping-progress]');
    if (message) message.textContent = remaining ? `${money.format(remaining / 100)} away from free U.S. shipping.` : 'You unlocked free U.S. shipping.';
    if (progress) progress.style.width = `${Math.min(100, (cart.total_price / 7500) * 100)}%`;
    if (!lines) return;
    if (!cart.items.length) {
      lines.innerHTML = '<div class="cart-empty"><p class="eyebrow">The ritual awaits</p><h3>Your bag is empty.</h3><p>Choose a botanical essential to begin.</p></div>';
      return;
    }
    lines.innerHTML = cart.items.map((item, index) => `
      <article class="drawer-line">
        ${item.image ? `<img src="${escapeHtml(item.image)}&width=180" alt="${escapeHtml(item.product_title)}">` : '<span></span>'}
        <div>
          <h3>${escapeHtml(item.product_title)}</h3>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeHtml(item.variant_title)}</p>` : ''}
          <strong>${money.format(item.final_line_price / 100)}</strong>
          <div class="drawer-line-controls">
            <div class="quantity-control" aria-label="Quantity">
              <button type="button" data-line-change="${index + 1}" data-quantity="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-line-change="${index + 1}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
            <button class="remove-line" type="button" data-line-change="${index + 1}" data-quantity="0">Remove</button>
          </div>
        </div>
      </article>`).join('');
  };

  const getCart = async () => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load your bag.');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  document.addEventListener('click', async event => {
    if (event.target.closest('[data-cart-open]')) {
      setDrawer(true);
      getCart().catch(error => showToast(error.message));
    }
    if (event.target.closest('[data-cart-close]')) setDrawer(false);
    const change = event.target.closest('[data-line-change]');
    if (change) {
      change.disabled = true;
      try {
        const response = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(change.dataset.lineChange), quantity: Number(change.dataset.quantity) })
        });
        if (!response.ok) throw new Error('Unable to update your bag.');
        renderCart(await response.json());
      } catch (error) {
        showToast(error.message);
        change.disabled = false;
      }
    }
  });

  document.addEventListener('keydown', event => { if (event.key === 'Escape') setDrawer(false); });

  document.querySelectorAll('[data-product-form]').forEach(form => {
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) {
          const data = await response.json();
          throw new Error(data.description || 'This item could not be added.');
        }
        await getCart();
        setDrawer(true);
        showToast('Added to your ritual.');
      } catch (error) {
        showToast(error.message);
      } finally {
        button.disabled = false;
        button.textContent = original;
      }
    });
  });

  getCart().catch(() => {});
})();
